export { default as document } from "./document";
export { default as window } from "./window";
export * from "./create-mock";